import { render } from "./TabelaFormValidacao.vue?vue&type=template&id=13f5a37c&scoped=true"
import script from "./TabelaFormValidacao.vue?vue&type=script&lang=js"
export * from "./TabelaFormValidacao.vue?vue&type=script&lang=js"

import "./TabelaFormValidacao.vue?vue&type=style&index=0&id=13f5a37c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f5a37c"]])

export default __exports__